<template>
  <v-card flat class="rounded-xl "> 
    <v-card-title>Đăng nhập tài khoản</v-card-title>
    <v-card-subtitle>Quét Qr để thực hiện đăng nhập</v-card-subtitle>
    
    <v-card-text>
      <v-btn small color="green" @click="activeCam=!activeCam" dark>active</v-btn> <br>
      {{ loginId }}
      <div class="scanner-wrapper" v-show="activeCam">
        <qrcode-stream @decode="onDecode" @init="onInit"></qrcode-stream>
        
        <div v-if="errorMessage" class="error-toast">
          {{ errorMessage }}
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>

import { QrcodeStream } from 'vue-qrcode-reader'
import {confirm} from "./api"

export default {
  components: {
    QrcodeStream,
  },
  methods: {
    onDecode(value) {
      this.loginId = value
      this.confirmLogin(value)
    },
    confirmLogin(loginId, status=true) {
      return confirm({
        "loginId": loginId,
        "approved": status
      })
    }, 
    // onInit handles permissions and camera setup
    async onInit(promise) {
      try {
        await promise;
        console.log('Camera started successfully');
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.errorMessage = 'User denied camera access.';
        } else if (error.name === 'NotSupportedError') {
          this.errorMessage = 'HTTPS is required for camera access.';
        } else {
          this.errorMessage = 'Camera error: ' + error.message;
        }
      }
    },
  },
  data() {
    return {
      activeCam: false,
      loginId: null
    }
  }
}
</script>
<style scoped>
.scanner-wrapper {
  /* Set your desired size here */
  width: 300px;
  height: 300px;
  
  /* Centers the scanner */
  margin: 0 auto;
  
  /* Ensures the video doesn't "leak" out if the aspect ratio differs */
  /* overflow: hidden;
  border-radius: 12px;
  border: 2px solid #42b983; Optional: adds a nice border */
}
</style>
